import { Button, SettingsIcon, Stack } from '@all-manager/design-system-v2';
import FullPageLayout from '../../../../layout/FullPageLayout/FullPageLayout';
import AiStatusTag from '../../components/AiStatusTag/AiStatusTag';
import EmailDetailModal from '../../components/EmailDetailModal/EmailDetailModal';
import GoogleScriptModal from '../../components/GoogleScriptModal/GoogleScriptModal';
import InboxList from '../../components/InboxList/InboxList';
import SyncStatusBadge from '../../components/SyncStatusBadge/SyncStatusBadge';
import { useInboxPage } from './useInboxPage';

export default function InboxPage() {
  const hook = useInboxPage();

  return (
    <>
      <FullPageLayout
        htmlTitle="Boîte de réception"
        title="Boîte de réception"
        subtitle="Consultez les nouveaux emails et appliquez les actions automatiques suggérées."
        action={(
          <Stack direction="row" spacing={2} alignItems="center" wrap="wrap">
            <Stack direction="row" spacing={2} alignItems="center">
              <SyncStatusBadge spaceId={hook.currentSpace?.id} />
              <AiStatusTag spaceId={hook.currentSpace?.id} />
            </Stack>
            {hook.isAdmin ? (
              <Button
                variant="outlined"
                size="small"
                startIcon={<SettingsIcon />}
                onClick={hook.handleOpenConfigModal}
              >
                Configurer Gmail
              </Button>
            ) : null}
          </Stack>
        )}
        fixedHeader
      >
        <InboxList
          emails={hook.emails}
          isLoading={hook.isLoadingEmails}
          selectedEmailId={hook.selectedEmailId}
          onSelectEmail={hook.handleSelectEmail}
          currentTab={hook.currentTab}
          onTabChange={hook.handleTabChange}
          pendingCount={hook.pendingCount}
          searchTerm={hook.searchTerm}
          onSearchChange={hook.setSearchTerm}
          hasMore={hook.hasMoreEmails}
          isFetchingNextPage={hook.isFetchingNextPage}
          isLoadMoreError={hook.isLoadMoreError}
          onLoadMore={hook.handleLoadMore}
        />
      </FullPageLayout>

      <EmailDetailModal
        open={Boolean(hook.selectedEmail)}
        email={hook.selectedEmail}
        emails={hook.emails}
        totalEmails={hook.emailsCount}
        hasMoreEmails={hook.hasMoreEmails}
        onLoadMoreEmails={hook.handleLoadMoreEmails}
        spaceId={hook.currentSpace?.id || ''}
        onClose={hook.handleCloseDetailModal}
        onSelectEmail={hook.handleOpenEmail}
      />

      <GoogleScriptModal
        open={hook.isConfigModalOpen}
        onClose={hook.handleCloseConfigModal}
        spaceSlug={hook.currentSpace?.slug}
        spaceId={hook.currentSpace?.id}
      />
    </>
  );
}
